import { useState } from 'react';
import { Plus } from 'lucide-react';
import { UserList } from '../../components/admin/UserList';
import { AddUserModal } from '../../components/admin/AddUserModal';

export function AdminUsers() {
  const [showAdd, setShowAdd] = useState(false);
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-semibold">Users</h1>
        <button
          onClick={() => setShowAdd(true)}
          className="inline-flex items-center gap-1 rounded bg-blue-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-blue-700"
        >
          <Plus size={16} /> Add user
        </button>
      </div>
      <UserList />
      {showAdd && <AddUserModal onClose={() => setShowAdd(false)} />}
    </div>
  );
}
